export enum UserRoles {
  ADMIN = 'ADMIN',
  VIEWER = 'VIEWER'
}
